import { Col, Row, Tabs, Form, notification, message } from "antd";
import { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  useDeleteDriverByIdMutation,
  useGetDriverByIdQuery,
  useUpdateDriverByIdMutation,
  useUpdateDriverStatusByIdMutation,
  useDownloadDriverDocumentsMutation,
  useRequestDriverViewOtpMutation,
  useVerifyDriverViewOtpMutation,
} from "../../../feature/Driver/driverApiSlice";
import InlineOtpVerifyPanel from "../../Common/InlineOtpVerifyPanel";
import { PrimaryButton } from "../../styled/Button.styled";
import {
  LightBlueContainer,
  WhiteContainer,
} from "../../styled/Container.styled";
import BankDetails from "./addDriver/BankDetails";
import DocumentDetails from "./addDriver/DocumentDetails";
import PersonalDetails from "./addDriver/PersonalDetails";
import VehicleDetails from "./addDriver/VehicleDetails";
import WalletDetails from "./addDriver/WalletDetails";


import dayjs from "dayjs";
import appendData from "../../../utils/appendData";
import BookingHistory from "./addDriver/BookingHistory";
import styled from "styled-components"

function DriverDetails() {
  const { id } = useParams();
  const location = useLocation();
  const { data, isError, isLoading } = useGetDriverByIdQuery(id);
  const [updateDriverById] = useUpdateDriverByIdMutation();
  const navigate = useNavigate();
  
  const backToList = () => {
    const urlParams = new URLSearchParams(location.search);
    const page = urlParams.get('page') || '1';
    navigate(`/drivers?page=${page}`);
  };
  const [imageFile, setImageFile] = useState("");
  const [rcImage, setRCImage] = useState("");
  const [rcBackImage, setRCBackImage] = useState("");
  const [touristPermitFrontImage, setTouristPermitFrontImage] = useState("");
  const [touristPermitBackImage, setTouristPermitBackImage] = useState("");
  const [aadharFrontImage, setAadharFrontImage] = useState("");
  const [aadharBackImage, setAadharBackImage] = useState("");
  const [drivingLicenceFrontImage, setDrivingLicenceFrontImage] = useState("");
  const [drivingLicenceBackImage, setDrivingLicenceBackImage] = useState("");
  const [panFrontImage, setPanFrontImage] = useState("");
  const [statusUpdate, setStatusUpdate] = useState<boolean>();
  const [panBackImage, setPanBackImage] = useState("");
  const [deleteDriverById] = useDeleteDriverByIdMutation();
  const [updateDriverStatusById] = useUpdateDriverStatusByIdMutation();
  const [downloadDriverDocuments] = useDownloadDriverDocumentsMutation();
  const [isDownloading, setIsDownloading] = useState(false);

  // Download OTP gate: downloading the documents zip requires OTP verification
  const [requestDriverViewOtp] = useRequestDriverViewOtpMutation();
  const [verifyDriverViewOtp] = useVerifyDriverViewOtpMutation();
  const [isDownloadOtpOpen, setIsDownloadOtpOpen] = useState(false);
  const [isRequestingDownloadOtp, setIsRequestingDownloadOtp] = useState(false);
  const [isVerifyingDownloadOtp, setIsVerifyingDownloadOtp] = useState(false);
  const [downloadOtpError, setDownloadOtpError] = useState("");

  const requestDownloadOtp = async () => {
    try {
      setIsRequestingDownloadOtp(true);
      setDownloadOtpError("");
      await requestDriverViewOtp().unwrap();
      message.success("OTP sent to your registered phone number");
    } catch (error) {
      console.error("Error requesting download OTP:", error);
      message.error("Failed to send OTP. Please try again.");
    } finally {
      setIsRequestingDownloadOtp(false);
    }
  };

  const handleDownloadClick = async () => {
    if (!data?.data?.id) {
      message.error("Driver ID not found");
      return;
    }
    // OTP disabled until the OTP SMS template is registered on DLT
    // setIsDownloadOtpOpen(true);
    // await requestDownloadOtp();
    await performDownload();
  };

  const cancelDownloadOtp = () => {
    setIsDownloadOtpOpen(false);
    setDownloadOtpError("");
  };

  const handleVerifyDownloadOtp = async (otp: string) => {
    try {
      setIsVerifyingDownloadOtp(true);
      setDownloadOtpError("");
      await verifyDriverViewOtp(otp).unwrap();
      setIsDownloadOtpOpen(false);
      await performDownload();
    } catch (error) {
      console.error("Error verifying download OTP:", error);
      setDownloadOtpError("Invalid or expired OTP. Please try again.");
    } finally {
      setIsVerifyingDownloadOtp(false);
    }
  };

  const performDownload = async () => {
    const driverId = data?.data?.id;
    if (!driverId) {
      message.error("Driver ID not found");
      return;
    }
    try {
      setIsDownloading(true);
      const response = await downloadDriverDocuments(driverId.toString()).unwrap();

      const blob = new Blob([response], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `driver_documents_${driverId}_${new Date().toISOString().split("T")[0]}.zip`
      );
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      // message.success("Download completed. An OTP was sent to your phone -- use it as the password to open the zip.");
      message.success("Download completed.");
    } catch (error) {
      console.error("Error downloading documents:", error);
      message.error("Failed to download documents");
    } finally {
      setIsDownloading(false);
    }
  };

  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabChange = (key: any) => {
    setActiveTab(key);
  };
  const handleNextTab = () => {
    const tabs = ["tab1", "tab2", "tab3", "tab4", "tab5","tab6"];
    const currentIndex = tabs.indexOf(activeTab);
    const nextIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
    const nextTab = tabs[nextIndex];
    setActiveTab(nextTab);
  };
  const handlePrevTab = () => {
    const tabs = ["tab1", "tab2", "tab3", "tab4", "tab5","tab6"];
    const currentIndex = tabs.indexOf(activeTab);
    const nextIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex - 1;
    const nextTab = tabs[nextIndex];
    setActiveTab(nextTab);
  };


  const declineHandler = (id: any) => {
    deleteDriverById(id)
      .unwrap()
      .then(() => {
        notification.success({
          message: "Driver successfully un-verified",
          placement: "bottomLeft",
        });
      })
      .catch((error: any) => {
        notification.error({
          message: "Error",
          description: error.data.message,
          placement: "bottomLeft",
        });
      });
  };

  return (
    <>
      <div style={{ position: "relative" }}>
      <Form.Provider
        onFormFinish={async (name, { forms }) => {
          if (name === "submitForm") {
            const {
              personalDetailForm,
              vehicleDetailForm,
              documentDetailForm,
              bankDetailForm,
            } = forms;

            // submit() below does not wait for the rules, so check them first and stop on any error.
            try {
              await personalDetailForm?.validateFields();
            } catch {
              setActiveTab("tab1");
              notification.error({
                message: "Invalid details",
                description: "Please correct the highlighted fields in Personal Details.",
                placement: "topLeft",
              });
              return;
            }

            personalDetailForm?.submit();
            vehicleDetailForm?.submit();
            documentDetailForm?.submit();
            bankDetailForm?.submit();

            let driverData = { ...personalDetailForm.getFieldsValue() };
            let vehicleData = vehicleDetailForm ? { ...vehicleDetailForm.getFieldsValue() } : data?.data.vehicleDto;
            // Ensure chassisNumber is never sent in update payload
            if (vehicleData && "chassisNumber" in (vehicleData as any)) {
              delete (vehicleData as any).chassisNumber;
            }
            let documentData = documentDetailForm ? { ...documentDetailForm.getFieldsValue() } : {
                  aadhaarNumber: data?.data.documentList[0]?.cardNumber,
                  drivingNumber: data?.data.documentList[2]?.cardNumber,
                  panNumber: data?.data.documentList[1]?.cardNumber,
            };
            let bankData = bankDetailForm ? { ...bankDetailForm.getFieldsValue() } : data?.data.bankDetails;
            //let accountId = bankDetailForm ? bankDetailForm.getFieldsValue().accountId : data?.data.accountId;
            let obj = {
              ...driverData,
              image: imageFile,
              dob: dayjs(driverData.dob).format("DD/MM/YYYY"),
              cabStand: driverData.cabStand,
              isActive: data?.data.isActive,
              isVerified: data?.data.isVerified,
              vehicleDto: vehicleDetailForm ? {
                ...vehicleData,
                vehicleMake: [
                  {
                    id: vehicleData.vehicleMake
                  }
                ],
                vehicleYear: dayjs(vehicleData.vehicleYear).format("YYYY"),
                touristPermitDTO: {
                  touristPermitNumber: vehicleData.touristPermitDTO?.touristPermitNumber || "",
                  touristPermitFrontImage: touristPermitFrontImage || data?.data?.vehicleDto?.touristPermitDTO?.touristPermitFrontImage,
                  touristPermitBackImage: touristPermitBackImage || data?.data?.vehicleDto?.touristPermitDTO?.touristPermitBackImage
                },
                rcImage: {
                  rcNumber: vehicleData.rcNumber,
                  rcFrontImage: rcImage || data?.data?.vehicleDto?.rcImage?.rcFrontImage,
                  rcBackImage: rcBackImage || data?.data?.vehicleDto?.rcImage?.rcBackImage
                }
              } : {
                ...vehicleData
              },
              bankDetails: bankData,
              //accountId: accountId,
              ...documentData,
              aadhaarFrontImage: documentDetailForm ? aadharFrontImage : data?.data?.documentList[0]?.cardFrontImage,
              aadhaarBackImage: documentDetailForm ? aadharBackImage : data?.data?.documentList[0]?.cardBackImage,
              drivingFrontImage: documentDetailForm ? drivingLicenceFrontImage : data?.data?.documentList[2]?.cardFrontImage,
              drivingBackImage: documentDetailForm ? drivingLicenceBackImage : data?.data?.documentList[2]?.cardBackImage,
              panImage: documentDetailForm ? panFrontImage : data?.data?.documentList[1]?.cardFrontImage,
            };
            updateDriverById({ id: data?.data.id, formData: obj })
              .unwrap()
              .then(() => {
                notification.success({
                  message: "Successfully Added!",
                  placement: "bottomLeft",
                });
                backToList();
              })
              .catch((error: any) => {
                notification.error({
                  message: "Error!",
                  description: error?.data?.message || "Something went wrong",
                  placement: "bottomLeft",
                });
              });
          }
        }}
      >
        <Row justify="end" gutter={20} className="button-bottom-margin">
          <Col>
            <PrimaryButton onClick={backToList}>Back to List</PrimaryButton>
          </Col>
          <Col>
            {activeTab !== "tab1" ? (
              <PrimaryButton onClick={handlePrevTab}>Back</PrimaryButton>
            ) : (
              ""
            )}
          </Col>
          <Col>
            {activeTab !== "tab6" ? (
              <PrimaryButton onClick={handleNextTab}>Next</PrimaryButton>
            ) : (
              ""
            )}
          </Col>
          <Col>
            <Form name="submitForm">
              {data?.data.isVerified === true ?
                (
                  <PrimaryButton htmlType="submit">Update</PrimaryButton>
                ) : activeTab === "tab4" && (
                  <>
                    <PrimaryButton style={{ background: "red" }} onClick={() => declineHandler(data?.data.id)}>Decline</PrimaryButton>
                    <PrimaryButton style={{ marginLeft: "10px", background: "green" }} onClick={() => { if (data?.data.id) { updateDriverStatusById(data?.data.id).then((res: any) => { if (res) { backToList(); } }); } }}>Approve</PrimaryButton>
                  </>
                )}
            </Form>
          </Col>
        </Row>

        <LightBlueContainer>
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
          >
            <Tabs.TabPane tab="Personal" key="tab1" disabled={true} forceRender>
              <WhiteContainer>
                {!isError && !isLoading && data && (
                  <PersonalDetails data={data} setImageFile={setImageFile} />
                )}
              </WhiteContainer>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Vehicle" key="tab2" disabled={true} forceRender>
              <WhiteContainer>
                {!isError && !isLoading && data && (
                  <VehicleDetails
                    data={data}
                    setRCImage={setRCImage}
                    setRCBackImage={setRCBackImage}
                    setTouristPermitFrontImage={setTouristPermitFrontImage}
                    setTouristPermitBackImage={setTouristPermitBackImage}
                    readOnly={true}
                  />
                )}
              </WhiteContainer>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Document" key="tab3" disabled={true} forceRender>
              <WhiteContainer className="document-details-container">
                {!isError && !isLoading && data && (
                <DocumentDetails
                  data={data}
                  setAadharFrontImage={setAadharFrontImage}
                  setAadharBackImage={setAadharBackImage}
                  setDrivingLicenceFrontImage={setDrivingLicenceFrontImage}
                  setPanFrontImage={setPanFrontImage}
                  isDownloading={isDownloading}
                  onDownloadClick={handleDownloadClick}
                />
                )}
              </WhiteContainer>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Bank" key="tab4" disabled={true} forceRender>
              <WhiteContainer>
                {!isError && !isLoading && data && <BankDetails data={data} />}
              </WhiteContainer>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Booking History" key="tab5" disabled={true}>
              <WhiteContainer>
                <BookingHistory />
              </WhiteContainer>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Wallet" key="tab6" disabled={true}>
              <WhiteContainer>
                <WalletDetails data={data}/>
              </WhiteContainer>
            </Tabs.TabPane>
          </Tabs>
        </LightBlueContainer>
      </Form.Provider>
      {isDownloadOtpOpen && (
        <InlineOtpVerifyPanel
          title="Verify OTP to Download Documents"
          description={
            downloadOtpError ||
            "An OTP has been sent to the admin's registered phone number. Enter it below to download this driver's documents."
          }
          isVerifying={isVerifyingDownloadOtp || isRequestingDownloadOtp}
          verifyButtonLabel="Verify & Download"
          onVerify={handleVerifyDownloadOtp}
          onCancel={cancelDownloadOtp}
          onResend={requestDownloadOtp}
        />
      )}
      </div>
    </>
  );
}

export default DriverDetails;
